import React from 'react';
import CompleteView from './CompleteView';

const Complete = ({ onComplete }: { onComplete: () => void }) => {
  return <CompleteView onComplete={onComplete} />;
};

export default Complete;
